import React from 'react';

export const Drots = () => (
<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.00065 5.0835L9.16732 0.91683L0.833984 0.91683L5.00065 5.0835Z" fill="#909EBB"/>
</svg>
)